"use client";

import { Suspense } from "react";
import NotFoundView from "@/views/NotFound";

export default function NotFound() {
  return (
    <Suspense fallback={null}>
      <NotFoundView />
    </Suspense>
  );
}
